// Iter 169 → 170 (Phase B + Danny rep_activity_drill_down_spec.md).
// Canonical contact-role taxonomy. Mirrors `CONTACT_ROLES` /
// `DECISION_MAKER_ROLES` in /app/backend/server.py. Changing either side
// without the other will silently break the rep-activity decision-maker
// rollup, so keep them in lockstep.
//
// Iter 170 (Josh approved 2026-06-05) — expanded from 6 to 11 roles per
// Danny's rep activity drill-down spec.
//
// `tier` is informational (display grouping in the Snapshot panel + future
// Reports analytics). `decisionMaker` is the canonical flag that drives
// the backend rollup.

export const CONTACT_ROLES = [
  // Gatekeeper tier
  { id: "front_desk",           label: "Front desk / Receptionist", short: "FD",   tier: "gatekeeper",            decisionMaker: false, color: "muted" },
  { id: "medical_assistant",    label: "Medical Assistant (MA)",    short: "MA",   tier: "clinical_support",      decisionMaker: false, color: "muted" },
  { id: "nurse_clinical_staff", label: "Nurse / Clinical staff",    short: "RN",   tier: "clinical_support",      decisionMaker: false, color: "muted" },
  { id: "np_pa",                label: "NP / PA",                   short: "NP",   tier: "clinical_decision",     decisionMaker: false, color: "medium" },
  // Administrative tier
  { id: "billing_rcm",          label: "Billing / RCM Staff",       short: "RCM",  tier: "admin_support",         decisionMaker: false, color: "medium" },
  { id: "office_manager",       label: "Office Manager",            short: "OM",   tier: "admin_decision",        decisionMaker: true,  color: "medium" },
  { id: "practice_admin",       label: "Practice Administrator",    short: "PA",   tier: "admin_decision",        decisionMaker: true,  color: "medium" },
  // Clinical decision-maker tier
  { id: "physician",            label: "Physician / Doctor",        short: "MD",   tier: "clinical_decision",     decisionMaker: true,  color: "strong" },
  { id: "owner_partner",        label: "Physician Owner / Partner", short: "OWN",  tier: "clinical_decision",     decisionMaker: true,  color: "strong" },
  // Executive tier
  { id: "executive",            label: "Executive (CEO/CFO/COO)",   short: "EXEC", tier: "executive",             decisionMaker: true,  color: "executive" },
  // Catch-all
  { id: "other",                label: "Other",                     short: "—",    tier: "other",                 decisionMaker: false, color: "muted" },
];

export const DECISION_MAKER_ROLE_IDS = new Set(
  CONTACT_ROLES.filter((r) => r.decisionMaker).map((r) => r.id)
);

export const isDecisionMakerRole = (roleId) =>
  !!roleId && DECISION_MAKER_ROLE_IDS.has(roleId);

export const labelForRole = (roleId) => {
  const found = CONTACT_ROLES.find((r) => r.id === roleId);
  return found ? found.label : null;
};

// Color used in the Performance Snapshot panel + Activity Detail contact
// column. Mirrors the spec's "Display color" rule: muted/medium/strong
// blue for clinical/admin tiers, purple for executive.
export const colorForRole = (roleId) => {
  const r = CONTACT_ROLES.find((x) => x.id === roleId);
  if (!r) return "#94a3b8";
  switch (r.color) {
    case "executive": return "#7c3aed";   // purple
    case "strong":    return "#1d4f91";   // strong blue
    case "medium":    return "#2563eb";   // medium blue
    case "muted":
    default:          return "#64748b";   // muted blue-gray
  }
};

// Stable display order for the Snapshot Section 2 breakdown table. We
// surface decision-makers FIRST so reps see at a glance whether they're
// reaching the right people.
export const SNAPSHOT_DISPLAY_ORDER = [
  "physician",
  "owner_partner",
  "executive",
  "office_manager",
  "practice_admin",
  "np_pa",
  "billing_rcm",
  "nurse_clinical_staff",
  "medical_assistant",
  "front_desk",
  "other",
  "untagged",
];
